import { MDBAnimation, MDBContainer } from "mdbreact";
import React from "react";
import { connect } from "react-redux";
import { Button } from "semantic-ui-react";
import { redirectToMedproId } from "~/store/login/actions";
import styles from "./style.module.scss";

const AdServices = () => {
  return (
    <MDBAnimation className={styles.advance_medpro}>
      <div className={styles.adService_medpro_2}>
        <MDBContainer className={styles.containerService}>
          <div className={styles.content}>
            <h2>Đa dạng dịch vụ y tế</h2>
            <p>
              Chăm sóc sức khoẻ toàn diện: Đặt lịch khám bệnh, xét nghiệm, tư
              vấn sức khoẻ,.. tiện lợi, ngay tại nhà.
            </p>
            <a href="https://medpro.vn" target="_blank" rel="noreferrer">
              <Button className={styles.button}>Xem thêm</Button>
            </a>
          </div>
        </MDBContainer>
      </div>
    </MDBAnimation>
  );
};

const mapStateToProps = state => ({
  user: state.user
});

export default connect(mapStateToProps, { redirectToMedproId })(AdServices);
